// extracted by mini-css-extract-plugin
export default {"searchBar":"SearchBar_searchBar__xUq3F","termInfo":"SearchBar_termInfo__KG1Oh","inputContainer":"SearchBar_inputContainer__0KjQ3","input":"SearchBar_input__gMoru"};